import { Cookies } from 'react-cookie';

import { ChangeTrapLocationFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PutTrapNewLocationInterface {
  slug: string;
  action: 'new_place' | 'adjustment';
  plan_id?: number;
  newLocationData: ChangeTrapLocationFormValues;
}

export const putTrapNewLocation = async ({ slug, action, newLocationData, plan_id }: PutTrapNewLocationInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/traps/${slug}/location/${action}/`,
    {
      ...newLocationData,
    },
    {
      params: {
        plan_id,
      },
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
